import { useNavigate } from "react-router-dom";
import { Heart, MousePointerClick, Zap, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";

const steps = [
    { icon: Zap, title: "Tweet to list", body: "Drop your App Store or site URL, post the template on X, paste the tweet. No account and no card." },
    { icon: Heart, title: "Likes rank you", body: "Crowd #1 is the listing tweet with the most likes. Earlier list wins a tie. Boost is a like on that tweet." },
    { icon: MousePointerClick, title: "Get seen & clicked", body: "Visitors browse the board and click through to your app. Featured paid slots open later, labelled as paid placement." },
];

export default function About() {
    const navigate = useNavigate();
    return (
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-10">
            <div className="grid md:grid-cols-2 gap-8 items-center">
                <div>
                    <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight">
                        The fitness board where <span className="text-brand">likes rank you</span>.
                    </h1>
                    <p className="text-muted-foreground mt-4">
                        outbid.fit is a public crowd board for indie fitness apps, workout trackers, and digital fitness products.
                        You list with a tweet. Rank is likes on that tweet. No algorithm and no account.
                    </p>
                    <p className="text-muted-foreground mt-3">
                        Paid featured slots are a later layer. They will sit above the crowd board and stay labelled as paid placement. Likes will still rank Crowd #1.
                    </p>
                    <div className="mt-6 flex flex-col sm:flex-row gap-3">
                        <Button data-testid="about-list-button" onClick={() => navigate("/list")} className="bg-brand text-primary-foreground hover:bg-brand-dim font-semibold">
                            <Zap className="h-4 w-4 mr-2" /> List your app
                        </Button>
                        <Button data-testid="about-leaderboard-button" variant="outline" onClick={() => navigate("/")} className="font-semibold">
                            View the board
                        </Button>
                    </div>
                    <p className="mt-4 text-xs text-muted-foreground inline-flex items-center gap-1.5">
                        <ShieldCheck className="h-3.5 w-3.5 text-brand" /> Free to list · No accounts · Fitness only
                    </p>
                </div>
                <div className="relative rounded-2xl overflow-hidden border border-border min-h-[280px] hidden md:block">
                    <img
                        src="https://images.pexels.com/photos/32996769/pexels-photo-32996769.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                        alt="Fitness training"
                        className="absolute inset-0 h-full w-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />
                </div>
            </div>

            <div className="grid sm:grid-cols-3 gap-4 mt-12">
                {steps.map((s) => (
                    <Card key={s.title} className="bg-card border-border p-5">
                        <span className="grid place-items-center h-10 w-10 rounded-lg bg-brand/15 text-brand mb-3">
                            <s.icon className="h-5 w-5" />
                        </span>
                        <h3 className="font-heading font-semibold">{s.title}</h3>
                        <p className="text-sm text-muted-foreground mt-1">{s.body}</p>
                    </Card>
                ))}
            </div>
        </div>
    );
}
